module.exports = __webpack_public_path__ + "img/unboxing.2de3d096.svg";